import React from "react";
import Box from "@mui/material/Box";

const UITableActionCell = ({ children, justify = "center", sx }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: justify,
        gap: 1,
        width: "100%",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default UITableActionCell;
